/**
 * Phonics Letter Nn — 课程数据配置
 *
 * 特殊说明：
 * 1. Story 台词忽略音标（PPT P5 中的 /stɒp/ 等音标不保留）
 * 2. Story 1 排版和 Mm 的 Story 1 一样（story-video-left-lines-right 布局）
 * 3. P7/P8 是数字学习页面（1-5 和 6-10），使用 number-grid 布局
 * 4. 英文长句时，中文翻译另起一行（前端渲染处理）
 */

const MEDIA_BASE = '/media/phonics/nn';
const V = 'v1';

export const letterData = {
  letter: 'N',
  title: 'Phonics',
  subtitle: 'Letter Nn',

  mediaBase: MEDIA_BASE,

  // Step 1: 歌曲视频片段 (00:10 - 01:31 = 81秒)
  songVideo: {
    src: `${MEDIA_BASE}/Nn.mp4?${V}`,
    poster: `${MEDIA_BASE}/cover.png?${V}`,
    startTime: 10,
    endTime: 91,
  },

  // Step 2: 4 格单词视频 (nut / nine / nest / net)
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_word1.mp4?${V}`, cover: `${MEDIA_BASE}/image7.png?${V}` },
    { id: 2, src: `${MEDIA_BASE}/video_s3_word2.mp4?${V}`, cover: `${MEDIA_BASE}/image8.png?${V}` },
    { id: 3, src: `${MEDIA_BASE}/video_s3_word3.mp4?${V}`, cover: `${MEDIA_BASE}/image9.png?${V}` },
    { id: 4, src: `${MEDIA_BASE}/video_s3_word4.mp4?${V}`, cover: `${MEDIA_BASE}/image10.png?${V}` },
  ],

  // Story 和数字学习页面
  storySections: [

    // web P3: Learn the Story (1) — 左视频 + 左下/右边台词（和 Mm 的 Story 1 一样）
    {
      label: 'Learn the Story (1)',
      layout: 'story-video-left-lines-right',
      videos: [{
        src: `${MEDIA_BASE}/video_story_nuts.mp4?${V}`,
      }],
      // PPT P5 内容（忽略音标）：
      // Hey stop. Naughty Ned. / stop / naughty
      // There are nine nuts. / there / there are
      // No, no. I want these nuts. / want / these
      splitAt: 3,
      lines: [
        // 左下（前3条）：PPT 右侧上半部分
        { en: 'There are nine nuts.', cn: '那里有9个坚果。', cnNewLine: true, audioEn: `${MEDIA_BASE}/story1_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3?${V}` },
        { en: 'there', cn: '那里', audioEn: `${MEDIA_BASE}/w_en_there.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_there.mp3?${V}` },
        { en: 'there are', cn: '那里有', audioEn: `${MEDIA_BASE}/s_en_there_are.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_there_are.mp3?${V}` },
        // 右边（后6条）：PPT 左侧 + 右侧下半部分
        { en: 'Hey stop. Naughty Ned.', cn: '嘿，停下。淘气的 Ned。', cnNewLine: true, audioEn: `${MEDIA_BASE}/story1_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3?${V}` },
        { en: 'stop', cn: '停下', audioEn: `${MEDIA_BASE}/w_en_stop.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_stop.mp3?${V}` },
        { en: 'naughty', cn: '淘气的', audioEn: `${MEDIA_BASE}/w_en_naughty.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_naughty.mp3?${V}` },
        { en: 'No, no. I want these nuts.', cn: '不不。我想要这些坚果。', cnNewLine: true, audioEn: `${MEDIA_BASE}/story1_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_3.mp3?${V}` },
        { en: 'want', cn: '想要', audioEn: `${MEDIA_BASE}/w_en_want.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_want.mp3?${V}` },
        { en: 'these', cn: '这些', audioEn: `${MEDIA_BASE}/w_en_these.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_these.mp3?${V}` },
      ],
    },

    // web P4: Learn the Story (2) — Story 2（第一组台词）
    {
      label: 'Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      videos: [{
        src: `${MEDIA_BASE}/video_story_nest.mp4?${V}`,
      }],
      // PPT P6 第一组台词（3句纯句子）
      lines: [
        { en: 'There are nine eggs.', cn: '那里有9个鸡蛋。', audioEn: `${MEDIA_BASE}/story2_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_1.mp3?${V}` },
        { en: 'Hey stop. Naughty Ned.', cn: '嘿，停下。淘气的 Ned。', audioEn: `${MEDIA_BASE}/story2_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_2.mp3?${V}` },
        { en: 'No, no. I want this nest.', cn: '不不。我想要这个鸟巢。', audioEn: `${MEDIA_BASE}/story2_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_3.mp3?${V}` },
      ],
    },

    // web P5: Learn the Story (3) — Story 3（第二组台词）
    {
      label: 'Learn the Story (3)',
      layout: 'video-top-lines-bottom',
      videos: [{
        src: `${MEDIA_BASE}/video_story_net.mp4?${V}`,
      }],
      // PPT P6 第二组台词（3句纯句子）
      lines: [
        { en: 'There are nine fish.', cn: '那里有9条鱼。', audioEn: `${MEDIA_BASE}/story3_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_1.mp3?${V}` },
        { en: 'Hey stop. Naughty Ned.', cn: '嘿，停下。淘气的 Ned。', audioEn: `${MEDIA_BASE}/story3_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_2.mp3?${V}` },
        { en: 'No, no. I want this net.', cn: '不不。我想要这个网。', audioEn: `${MEDIA_BASE}/story3_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_3.mp3?${V}` },
      ],
    },

    // web P6: Count 1-5 — 数字学习页面（两行：上1/3/5，下2/4）
    {
      label: 'Count 1-5',
      layout: 'number-grid-2row',
      headerTitle: '跟着说',
      rows: [
        [
          { src: `${MEDIA_BASE}/image15.png?${V}`, number: '1', word: 'one', audio: `${MEDIA_BASE}/num_en_1.mp3?${V}` },
          { src: `${MEDIA_BASE}/image11.png?${V}`, number: '3', word: 'three', audio: `${MEDIA_BASE}/num_en_3.mp3?${V}` },
          { src: `${MEDIA_BASE}/image13.png?${V}`, number: '5', word: 'five', audio: `${MEDIA_BASE}/num_en_5.mp3?${V}` },
        ],
        [
          { src: `${MEDIA_BASE}/image14.png?${V}`, number: '2', word: 'two', audio: `${MEDIA_BASE}/num_en_2.mp3?${V}` },
          { src: `${MEDIA_BASE}/image12.png?${V}`, number: '4', word: 'four', audio: `${MEDIA_BASE}/num_en_4.mp3?${V}` },
        ],
      ],
    },

    // web P7: Count 6-10 — 数字学习页面（两行：上6/8/10，下7/9）
    {
      label: 'Count 6-10',
      layout: 'number-grid-2row',
      headerTitle: '跟着说',
      rows: [
        [
          { src: `${MEDIA_BASE}/image19.png?${V}`, number: '6', word: 'six', audio: `${MEDIA_BASE}/num_en_6.mp3?${V}` },
          { src: `${MEDIA_BASE}/image21.png?${V}`, number: '8', word: 'eight', audio: `${MEDIA_BASE}/num_en_8.mp3?${V}` },
          { src: `${MEDIA_BASE}/image20.png?${V}`, number: '10', word: 'ten', audio: `${MEDIA_BASE}/num_en_10.mp3?${V}` },
        ],
        [
          { src: `${MEDIA_BASE}/image17.png?${V}`, number: '7', word: 'seven', audio: `${MEDIA_BASE}/num_en_7.mp3?${V}` },
          { src: `${MEDIA_BASE}/image18.png?${V}`, number: '9', word: 'nine', audio: `${MEDIA_BASE}/num_en_9.mp3?${V}` },
        ],
      ],
    },

  ],

  // 封面背景图
  coverBg: `${MEDIA_BASE}/image1.jpeg`,

  // 视频封面图（来自 AtoZ_cover/Nn.png）
  coverPoster: `${MEDIA_BASE}/cover.png?${V}`,
};

export default letterData;
